var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chrome Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SideNav-Revised",
    transform: "translate(-28.000000, -934.000000)",
    fill: "#F16334",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 933.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.400000, 1.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,0.3 C14.6374742,0.3 18.739496,4.30514737 18.8954031,9.30477964 L18.9,9.6 L18.9,17.86 L17.1,17.86 L17.1,9.6 C17.1,5.45786438 13.7421356,2.1 9.6,2.1 C5.54991183,2.1 2.24962571,5.31028416 2.10494637,9.32504775 L2.1,9.6 L2.1,17.86 L0.3,17.86 L0.3,9.6 C0.3,4.46375183 4.46375183,0.3 9.6,0.3 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Oval-Copy-3",
    points: "14.7 11.28 14.7 19.54 12.9 19.54 12.9 11.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Oval-Copy-4",
    points: "6.3 11.28 6.3 19.54 4.5 19.54 4.5 11.28"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.05512f85436239b5c6af0b10c93ac260.svg";
export { ForwardRef as ReactComponent };